<template>
  <div class="product-box">
    <div class="tit-fixed">
      <div class="jarallax-container">
        <div class="cst_container_base">
          <h1>{{ productForm.productClassName }}</h1>
          <h2></h2>
          <h3>{{ productForm.productName }}</h3>
        </div>
      </div>
    </div>
    
    <div class="list-wrap">
      <div class="zhanwei"></div>
      <div class="wrap">
        <div class="cbsect_5700dd5c">
          <div class="cbdiv_ad72d4a4">
            <div class="top_img">
              <img :src="productForm.longPic" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import News from '@/api/api.js'

export default {
  data() {
    return {
      productForm: {}
    };
  },
  created() {
    const id = this.$route.params.id;
    this.getProduct(id)
  },
  mounted() {
  },
  methods: {
    
    async getProduct(id) {
      let res = await News.getProduct(id);
      if (res.code === 0){
        // console.log(res)
        this.productForm = res.msg;
      } else{
        this.$message.error(res.msg);
      }
    }
  },
};
</script>
  
  <style lang="scss"  scoped >
  .tit-fixed .cst_container_base h3 {
    font-size: 20px;
  }
.product-box {
  position: relative;

  background: linear-gradient(rgba(28, 69, 135, 0.7), rgb(32, 18, 77)),
    url("../../assets/image/news_bg.jpg") center center / cover no-repeat;
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #99aeff;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px #99aeff;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .header-box {
    position: absolute;
    z-index: 9;
  }
  .header-top {
    position: fixed;
    z-index: 999;
  }
}
.cbsect_5700dd5c {
  padding-top: 0px;
  padding-bottom: 60px;
  min-height: 20px;
  .cbdiv_ad72d4a4 {
    margin: 0 auto;
    width: var(--base-width);
    color: #fff;
    box-shadow: 0 0 6px rgba(0,0,0,0.12);
    .top_img {
      width: 100%;
      img {
        width: 100%;
        // height: 400px;
        margin-top: -100px;
      }
    }
  }
}


.animate {
  opacity: 0;
}
.fadeInUpBig {
  animation: fadeInUpBig 1s;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/ProductCategoryDetail.vue